import { useRef } from 'react';

// Adapted from https://usehooks.com/usePrevious/
export function usePreviousValue<T>(value: T): T {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = useRef<T>(value);
    const oldValue = ref.current;
    ref.current = value;

    return oldValue;
}
